'use client';
import React, { useState, useEffect, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';

let signalstopic = 'goldensparrowcapital-signals';

const WatchersComponent = props => {
  // Function to get the last 7 days
  const [lowestPrices, setLowestPrices] = useState([]);
  const [watchers, setWatchers] = useState([]);
  const [watchersHitStopLossPrice, setWatchersHitStopLossPrice] = useState([]);
  const [section, setSection] = useState('Active')
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // this will prevent receving the subscribed message multiple times
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [isProcessing, setIsProcessing] = useState(false)
  // Subscribe on mount
  useEffect(() => {
    // const handleVisibilityChange = () => {
    //   if (document.hidden) {
    //     unsubscribeFromSymbols();
    //   } else {
    //    getWatchers()
    //   }
    // };

    const handleBeforeUnload = () => {
      unsubscribeFromSymbols();
    };

    // document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      unsubscribeFromSymbols();
      // document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  //connect and subscribe to MQTT broker
  const _connectMQTT = async props => {
    let now = new Date().valueOf()
    if (!client) {
      let clientID = 'GoldenSparrowCapital-' + Math.random().toString(16).substring(2, 8);
      const gsccookie = Cookies.get('gsccookie') || null;
      const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
        clientId: clientID,
        username: 'user-jwt',
        password: gsccookie,
        clean: true,
        rejectUnauthorized: true,
        reconnectPeriod: 60000,
      });
      mqttClientRef.current = newClient;
      newClient.on('connect', async () => {
        console.log('Connected to MQTT:', new Date().toLocaleTimeString());

        newClient.publish("GET_WATCHERS", JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
            setIsProcessing(true)
            console.log('GET_WATCHERS request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });

        newClient.publish("GET_LOWESTPRICES", JSON.stringify({ token: gsccookie }), err => {
          if (!err) {
            console.log('GET_LOWESTPRICES request published:', new Date().toLocaleTimeString());
          } else {
            console.error('Topic Publish error', err);
          }
        });

        newClient.subscribe('RECEIVE_WATCHERS_WEB', err => {
          if (!err) {
            // console.log('Topic subscribed:ALL_WATCHERS');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });

        newClient.subscribe('ADD_WATCHER', err => {
          if (!err) {
            // console.log('Topic subscribed: ADD_WATCHER');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });

        newClient.subscribe('UPDATE_WATCHER', err => {
          if (!err) {
            // console.log('Topic subscribed: UPDATE_WATCHER');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });

        newClient.subscribe('DELETE_WATCHER', err => {
          if (!err) {
            // console.log('Topic subscribed: UPDATE_WATCHER');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });

        newClient.subscribe('ADD_Watcher_To_StopLoss', err => {
          if (!err) {
            // console.log('Topic subscribed: UPDATE_WATCHER');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });
        newClient.subscribe('RECEIVE_LOWESTPRICES', err => {
          if (!err) {
            // console.log('Topic subscribed: UPDATE_WATCHER');
          } else {
            console.error('Topic Subscribe error', err);
          }
        });
      });

      setClient(newClient);
    }
  };


  useEffect(() => {
    async function fetchData() {
      if (client) {
        client.on('message', (topic, message) => {
          console.log('Received message:', topic, new Date().toLocaleTimeString());
           if (topic == 'ADD_WATCHER') {
            let mm = JSON.parse(message);
            console.log('Watcher added:', mm.watcher);
            setWatchers(prev => [...prev, mm.watcher]);
            subscribeToSymbols(watchers);
            setLastUpdated(new Date().valueOf());
          }
          if (topic == 'RECEIVE_WATCHERS_WEB') {
            setIsProcessing(false)
            let ww = JSON.parse(message);
            let watchers = ww.watchers;
            //  console.log('Received Watchers:', watchers.length);
            setWatchers(watchers);
            subscribeToSymbols(watchers);
            setLastUpdated(new Date().valueOf());
          }
        
          if (topic == 'UPDATE_WATCHER') {
            let obj = JSON.parse(message);
            let newWatcher = {
              uuid: obj.uuid,
              strategyName: obj.strategyName,
              symbol: obj.symbol,
              timeFrame: obj.timeFrame,
              creationDate: obj.creationDate,
              orderType: obj.orderType,
              marketOrder: obj.marketOrder,
              numberOfDecimalValues: obj.numberOfDecimalValues,
              limitPrice: obj.limitPrice,
              limitPriceHit: obj.limitPriceHit,
              stopLossPrice: obj.stopLossPrice,
              stopLossHit: obj.stopLossHit,
              currentPrice: obj.currentPrice,
              minPriceAfterSignal: obj.minPriceAfterSignal,
              maxPriceAfterLimitPriceHit: obj.maxPriceAfterLimitPriceHit,
              limitPriceHitDateTime: obj.limitPriceHitDateTime
            };

            setWatchers(prev =>
              prev.map(item =>
                item.symbol === newWatcher.symbol
                  ? {
                    ...item,
                    limitPriceHit: newWatcher.limitPriceHit,
                    stopLossHit: newWatcher.stopLossHit,
                  }
                  : item
              )
            );


            setLastUpdated(new Date().valueOf());

          }
          if (topic == 'DELETE_WATCHER') {
            let obj = JSON.parse(message);
            setWatchers(prev => prev.filter(watcher => watcher.symbol !== obj.symbol));
            subscribeToSymbols(watchers);
          }
          if (topic == "ADD_Watcher_To_StopLoss") {
            let watcher = JSON.parse(message);
            setWatchersHitStopLossPrice(prev => [...prev, watcher]);
          }
          if (topic == "RECEIVE_LOWESTPRICES") {
            let prices = JSON.parse(message);
            // console.log('Received lowest prices:', prices.lowestPrices);
            setLowestPrices(prices.lowestPrices);
          }

        });
      }
    }
    fetchData();
    return () => {
      if (client) {
        if (mqttClientRef.current) {
          console.log('Disconnecting...', new Date().toLocaleTimeString());
          mqttClientRef.current.end(); // Disconnect properly
          setClient(null);
        }
      }
    };
  }, [client]);

  useEffect(() => {
    async function fetchData() {
      // getWatchers();
      await _connectMQTT(props);

    }
    fetchData();
  }, []);



  useEffect(() => {
    const intervalId = setInterval(
      () => {
        subscribeToSymbols(watchers);
      },
      10 * 60 * 1000
    ); // every 10 minutes
    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  // Function to subscribe to real-time Binance prices
  const subscribeToSymbols = async (ww) => {
    unsubscribeFromSymbols();

    let symBolsToSubscribe = ww.filter(
      watcher =>
        (watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N') ||
        (watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
    );

    console.log("Subscribing to symbols:", symBolsToSubscribe.length);

    const streams = symBolsToSubscribe.map(w => `${w.symbol.toLowerCase()}@ticker`).join('/');
    const url = `wss://stream.binance.com:9443/stream?streams=${streams}`;

    wsRefBinance.current = new WebSocket(url);

    wsRefBinance.current.onmessage = event => {
      const message = JSON.parse(event.data);
      const { s: symbol, c: currentPrice } = message.data;

      setWatchers(prev =>
        prev.map(item =>
          item.symbol === symbol
            ? {
              ...item,
              currentPrice: Number(currentPrice).toFixed(item.numberOfDecimalValues),
              minPriceAfterSignal:
                currentPrice < item.minPriceAfterSignal ? currentPrice : item.minPriceAfterSignal,
              maxPriceAfterLimitPriceHit:
                currentPrice > item.maxPriceAfterLimitPriceHit
                  ? currentPrice
                  : item.maxPriceAfterLimitPriceHit,
            }
            : item
        )
      );

      // setWatchers(watchers.map(item =>
      //   item.symbol === symbol ? { ...item,
      //    currentPrice: currentPrice
      //    } : item
      // ));
      // let ss = [...data];
      // ss.forEach(watcher => {
      //   if (watcher.symbol === symbol.toUpperCase()) {
      //     watcher.currentPrice = Number(currentPrice).toFixed(watcher.numberOfDecimalValues);

      //   }
      // });

      // setWatchers(ss);
    };

    wsRefBinance.current.onerror = err => {
      // console.error("Binance WebSocket error:", err);
    };

    wsRefBinance.current.onclose = () => {
      // console.log("Binance WebSocket closed");
    };
  };

  // Function to unsubscribe/cleanup
  const unsubscribeFromSymbols = () => {
    if (wsRefBinance.current) {
      wsRefBinance.current.close();
      wsRefBinance.current = null;
      // console.log('Unsubscribed from Binance prices');
    }
  };


  // const getWatchers = async () => {
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getWatchers`, {
  //       method: 'GET',
  //       credentials: 'include',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //     });

  //     if (!response.ok) {
  //       setWatchers([]);
  //     }

  //     const data = await response.json();

  //     // Handle the standardized response format
  //     if (data.success && Array.isArray(data.data)) {
  //       // console.log(data.data)
  //       setWatchers(data.data);
  //       subscribeToSymbols(data.data);

  //       //  return data.data; // Return the array of watchers from the data property
  //     } else {
  //       console.error('Invalid response format:', data.message || 'Unknown error');
  //       // return [];
  //     }
  //   } catch (e) {
  //     console.error('Error fetching watchers:', e);
  //     // return [];
  //   }
  // };

  const getWatchersHitStopLoss = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/dashboard/getWatchersHitStopLoss`,
        {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        setWatchersHitStopLossPrice([]);
      }
      const data = await response.json();

      // Handle the standardized response format
      if (data.success && Array.isArray(data.data)) {
        // console.log(data.data)
        setWatchersHitStopLossPrice(data.data);
      } else {
        console.error('Invalid response format:', data.message || 'Unknown error');
        // return [];
      }
    } catch (e) {
      console.error('Error fetching watchers:', e);
      // return [];
    }
  };

  return watchers ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      {/* <h6 style={{ margin: 3, textAlign : "right", fontSize : 12 }}>Count: {watchers.length}</h6> */}
      {/* <h1 className="text-sm font-normal">{props.user.email + ',' + props.user.userType}</h1> */}
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray' }}> Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>
      <div style={{ marginTop: 5, display: 'flex', gap: 3, alignItems: "center" }}>
        <button
          style={{
            backgroundColor: section == "Active" ? '#fff' : "gray",
            color: section == "Active" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            setSection('Active')

          }}
        >
          Active (
          {
            watchers.filter(watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
              .length
          }
          )
        </button>
        <button
          style={{
            backgroundColor: section == "Waiting" ? '#fff' : "gray",
            color: section == "Waiting" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            setSection('Waiting')

          }
          }
        >
          Waiting (
          {
            watchers.filter(watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N')
              .length
          }
          )
        </button>
        <button
          style={{
            backgroundColor: section == "StopLossHistory" ? '#fff' : "gray",
            color: section == "StopLossHistory" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            {
              setSection('StopLossHistory')
              getWatchersHitStopLoss();
            }
          }
          }
        >
          Stop Loss Hit
        </button>
        <button
          style={{
            backgroundColor: section == "LowestPrices" ? '#fff' : "gray",
            color: section == "LowestPrices" ? "#282828" : "#fff",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            padding: 6,
            fontSize: 14
          }}
          onClick={() => {
            {
              setSection('LowestPrices')
              //         client.publish("GET_LOWESTPRICES", JSON.stringify({ token: gsccookie }), err => {
              //   if (!err) {
              //     console.log('GET_LOWESTPRICES request published:', new Date().toLocaleTimeString());
              //   } else {
              //     console.error('Topic Publish error', err);
              //   }
              // });
            }
          }
          }
        >
          Close to Lowest Price ({lowestPrices.length})
        </button>

      </div>
      <hr></hr>

      {/* Active */}
      {section == "Active" ? (
        <div>

          {watchers.filter(watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N')
            .length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>
                    <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Limit Price Hit Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Symbol, Current Price & Profit/Loss</th>

                    {props.user?.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    {/* <th className="text-sm py-2 px-4 border-b">Timeframe & Duration</th> */}

                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Price</th>

                    <th className="text-sm py-2 px-4 border-b">Maximum Price & Profit</th>
                    <th className="text-sm py-2 px-4 border-b">Minimum Price</th>

                    {props.user?.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}

                    {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
                  </tr>
                </thead>

                <tbody>
                  {_.orderBy(
                    watchers.filter(
                      watcher => watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N'
                    ),
                    'creationDate',
                    'desc'
                  ).map((watcher, index) => {
                    // let minusHours = hideAfterNHours * 24 * 1000 * 60 * 60; //6 days
                    // let now = new Date().valueOf();

                    // if (watcher.creationDate > now - minusHours) {
                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No. */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Limit Price Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher?.limitPriceHitDateTime).toLocaleDateString() +
                            ', ' +
                            new Date(watcher?.limitPriceHitDateTime).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}

                        <td className="text-xs py-2 px-4 border-b text-center">
                          <div style={{ alignItems: 'center', display: 'flex' }}>
                            <button
                              style={{
                                backgroundColor: '#0474c9',
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                        
                              onClick={() =>
                                window.open(
                                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                                  '_blank'
                                )
                              }
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>
                                <h6 style={{ paddingLeft: 5 }}>
                                  ${Number(watcher.currentPrice).toFixed(watcher.numberOfDecimalValues)}
                                </h6>
                                {/*
                              {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N' ? (
                                <h6 style={{ paddingLeft: 5 }}>
                                  (
                                  {(
                                    ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                    watcher.limitPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </h6>
                              ) : null} */}
                              </div>
                            </button>

                            {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N' ? (
                              <div style={{ backgroundColor : "white", borderRadius: 5, padding: 5 }}>
                              <h6 style={{
                                paddingLeft: 5, color: (
                                  ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                  watcher.limitPrice
                                ).toFixed(2) > 0 ? 'green' : 'red'
                              }}>
                                (
                                {(
                                  ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                  watcher.limitPrice
                                ).toFixed(2) + '%'}
                                )
                              </h6>
                              </div>
                            ) : null}
                          </div>
                        </td>

                        {/* Strategy */}
                        {props.user.userType == 'ADMIN' ? (
                          <td className="text-xs py-2 px-4 border-b text-center">
                            {watcher.strategyName}
                          </td>
                        ) : null}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.marketOrder}
                        </td>

                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {Number(
                                ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                              ).toFixed(2) + '%'}
                              )
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                ).toFixed(2) +
                                '%'}
                              )
                            </span>
                          ) : null}

                          {watcher.stopLossHit == 'Y' ? (
                            <button
                              style={{
                                borderRadius: 5,
                                fontSize: 12,

                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {Number(
                                    ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}
                        </td>

                        {/* Maximum Price & Profit */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.maxPriceAfterLimitPriceHit).toFixed(
                                watcher.numberOfDecimalValues
                              )}{' '}
                              (
                              {Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) + '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Minimum Price */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.minPriceAfterSignal).toFixed(
                                watcher.numberOfDecimalValues
                              )} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.minPriceAfterSignal) * 100) / watcher.minPriceAfterSignal
                                ).toFixed(2) +
                                '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => alert(watcher.symbol)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                    // }
                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>
          )}
        </div>
      ) : null}

      {/* Waiting */}
      {section == "Waiting" ? (
        <div>

          {watchers.filter(watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N')
            .length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>

                    <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Symbol & Current Price</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    {/* <th className="text-sm py-2 px-4 border-b">Timeframe & Duration</th> */}

                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss  Price</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}

                    {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
                  </tr>
                </thead>

                <tbody>
                  {_.orderBy(
                    watchers.filter(
                      watcher => watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N'
                    ),
                    'creationDate',
                    'desc'
                  ).map((watcher, index) => {
                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}
                        <td className="py-2 px-4 border-b">
                          <button
                            style={{
                              backgroundColor: '#0474c9',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() =>
                              window.open(
                                'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                                '_blank'
                              )
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>

                              <h6 style={{ paddingLeft: 5 }}>
                                ${Number(watcher.currentPrice).toFixed(watcher.numberOfDecimalValues)}
                              </h6>
                              {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == 'N' ? (
                                <h6 style={{ paddingLeft: 5 }}>
                                  (
                                  {(
                                    ((watcher.currentPrice - watcher.limitPrice) * 100) /
                                    watcher.limitPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </h6>
                              ) : null}
                            </div>
                          </button>
                        </td>

                        {/* Strategy NAme */}
                        {props.user.userType == 'ADMIN' ? (
                          <td className="text-xs py-2 px-4 border-b text-center">
                            {watcher.strategyName}
                          </td>
                        ) : null}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.marketOrder}
                        </td>
                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                              {-1 *
                                Number(
                                  ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                ).toFixed(2) +
                                '%'}
                              )
                            </span>
                          ) : null}

                          {watcher.stopLossHit == 'Y' ? (
                            <button
                              style={{
                                borderRadius: 5,
                                fontSize: 12,

                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {Number(
                                    ((watcher.limitPrice - watcher?.stopLossPrice) * 100) / watcher.stopLossPrice
                                  ).toFixed(2) + '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => alert(watcher.symbol)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                    // }
                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>

          )}
        </div>
      ) : null}

      {/* Stop Loss */}
      {section == "StopLossHistory" ? (
        <div>


          {watchersHitStopLossPrice.length > 0 ? (
            <div style={{ padding: 5 }}>
              <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
                <thead>
                  <tr>
                    <th className="text-sm py-2 px-4 border-b">S.No.</th>
                    <th className="text-sm py-2 px-4 border-b">Date & Time</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Hit Date & Time</th>

                    <th className="text-sm py-2 px-4 border-b">Symbol</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Strategy Name</th>
                    ) : null}
                    <th className="text-sm py-2 px-4 border-b">Signal</th>
                    {/* <th className="text-sm py-2 px-4 border-b">Timeframe & Duration</th> */}

                    <th className="text-sm py-2 px-4 border-b">Limit Price</th>
                    <th className="text-sm py-2 px-4 border-b">Stop Loss Price</th>

                    <th className="text-sm py-2 px-4 border-b">Maximum Price & Profit</th>
                    <th className="text-sm py-2 px-4 border-b">Minimum Price</th>

                    {props.user.userType == 'ADMIN' ? (
                      <th className="text-sm py-2 px-4 border-b">Delete</th>
                    ) : null}

                    {/* <th className="text-sm py-2 px-4 border-b">Maximum Loss</th> */}
                  </tr>
                </thead>

                <tbody>
                  {_.orderBy(
                    watchersHitStopLossPrice,
                    'creationDate',
                    'desc'
                  ).map((watcher, index) => {

                    return (
                      <tr key={watcher.uuid}>
                        {/* S.No */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                        </td>

                        {/* Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher.creationDate).toLocaleDateString() +
                            ', ' +
                            new Date(watcher.creationDate).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>
                        {/* Stop Loss HIt Date & Time */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {new Date(watcher?.stopLossHitDateTime).toLocaleDateString() +
                            ', ' +
                            new Date(watcher?.stopLossHitDateTime).toLocaleTimeString(undefined, {
                              hour12: true,
                            })}
                        </td>

                        {/* Symbol */}
                        <td className="py-2 px-4 border-b">
                          <button
                            style={{
                              backgroundColor: '#a0a2a4ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 5,
                            }}
                            // target="_blank"
                            // variant="contained"
                            // endIcon={<OpenInNewIcon fontSize="small" />}
                            // size="small"
                            // href={
                            //   "https://www.tradingview.com/chart/?symbol=BINANCE%3A" +
                            //   watcher.symbol
                            // }
                            onClick={() =>
                              window.open(
                                'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + watcher.symbol,
                                '_blank'
                              )
                            }
                          >
                            <div style={{ alignItems: 'center', display: 'flex' }}>
                              <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{watcher.symbol}</h4>

                              {/* <h6 style={{ paddingLeft: 5 }}>
                            ${Number(watcher.currentPrice).toFixed(watcher.numberOfDecimalValues)}
                          </h6> */}
                              {/* {watcher.limitPriceHit == 'Y' && watcher.stopLossHit == "N" ? 
                          <h6 style={{ paddingLeft: 5 }}>
                            (
                            {(
                              ((watcher.currentPrice - watcher.limitPrice) * 100) /
                              watcher.limitPrice
                            ).toFixed(2) + '%'}
                            )
                          </h6> : null } */}
                            </div>
                          </button>
                        </td>

                        {/* Strategy Name */}
                        {props.user.userType == 'ADMIN' ? (
                          <td className="text-xs py-2 px-4 border-b text-center">
                            {watcher.strategyName}
                          </td>
                        ) : null}

                        {/* Order Type */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher?.marketOrder}
                        </td>
                        {/* <td className="py-2 px-4 border-b text-center">
                      {watcher?.timeFrame + ' (' + watcher?.duration + ')'}
                    </td> */}

                        {/* Limit Price */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: 'grey' }}
                        >
                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.limitPriceHit == 'Y' ? (
                            <button
                              style={{
                                fontSize: 12,
                                borderRadius: 5,
                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                                </span>
                                <span style={{ paddingLeft: 2 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="green"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M9 12l2 2 4-4M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}

                          {watcher.limitPriceHit == 'N' && watcher.stopLossHit == 'Y' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.limitPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}
                        </td>

                        {/* Stop Loss */}
                        <td className="text-xs py-2 px-4 border-b text-center">
                          {watcher.stopLossHit == 'N' ? (
                            <span style={{ color: 'grey' }}>
                              ${Number(watcher.stopLossPrice).toFixed(watcher.numberOfDecimalValues)}
                            </span>
                          ) : null}

                          {watcher.stopLossHit == 'Y' ? (
                            <button
                              style={{
                                borderRadius: 5,
                                fontSize: 12,

                                padding: 5,
                              }}
                            >
                              <div style={{ alignItems: 'center', display: 'flex' }}>
                                <span>
                                  ${Number(watcher?.stopLossPrice).toFixed(watcher.numberOfDecimalValues)} (
                                  {-1 *
                                    Number(
                                      ((watcher.limitPrice - watcher?.stopLossPrice) * 100) /
                                      watcher.stopLossPrice
                                    ).toFixed(2) +
                                    '%'}
                                  )
                                </span>
                                <span style={{ paddingLeft: 1 }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="red"
                                    className="size-5"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </button>
                          ) : null}
                        </td>

                        {/* Maximum Price & Profit */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: watcher.maxPriceAfterLimitPriceHit > watcher.limitPrice ? 'green' : 'grey' }}
                        >
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.maxPriceAfterLimitPriceHit).toFixed(
                                watcher.numberOfDecimalValues
                              )}{' '}
                              (
                              {Number(
                                ((watcher.maxPriceAfterLimitPriceHit - watcher.limitPrice) * 100) /
                                watcher.limitPrice
                              ).toFixed(2) + '%'}
                              )
                            </>
                          ) : null}
                        </td>

                        {/* Minimum Price */}
                        <td
                          className="text-xs py-2 px-4 border-b text-center"
                          style={{ color: 'grey' }}
                        >
                          {watcher.limitPriceHit == 'Y' ? (
                            <>
                              $
                              {Number(watcher?.minPriceAfterSignal).toFixed(
                                watcher.numberOfDecimalValues
                              )}
                            </>
                          ) : null}
                        </td>

                        {/* Delete Button */}
                        <td className="py-2 px-4 border-b">
                          <div style={{ textAlign: 'center' }}>
                            <button
                              style={{
                                // backgroundColor: '#00ff00',

                                padding: 5,
                              }}
                              onClick={() => alert(watcher.symbol)}
                            >
                              {/* <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>Delete</h4> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                className="size-4"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    );

                  })}
                </tbody>
              </table>
              <h6 style={{ margin: 0, padding: 5, color: 'gray', fontSize: 12 }}>
                *Note: Signals will be removed automatically after 7 days.
              </h6>
            </div>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No signals.</h5>
            </div>
          )}
        </div>
      ) : null}

      {/* Lowest Prices Hit */}
      {section == "LowestPrices" ? (
        <div>
          {lowestPrices.length > 0 ? (
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="text-sm py-2 px-4 border-b">S.No.</th>
                  <th className="text-sm py-2 px-4 border-b">Last Updated</th>
                  <th className="text-sm py-2 px-4 border-b">Symbol</th>
                  <th className="text-sm py-2 px-4 border-b">Lowest Price</th>

                </tr>
              </thead>
              <tbody>
                {_.orderBy(lowestPrices, ['lastUpdated'], ['desc']).map((hit, index) => (
                  <tr key={index}>
                    {/* S.No */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <h6 style={{ paddingLeft: 1 }}>{index + 1}.</h6>
                    </td>
                    <td className="text-xs py-2 px-4 border-b text-center"> {new Date(hit.lastUpdated).toLocaleDateString() +
                      ', ' +
                      new Date(hit.lastUpdated).toLocaleTimeString(undefined, {
                        hour12: true,
                      })}</td>
                    {/* Symbol */}
                    <td className="text-xs py-2 px-4 border-b text-center">
                      <button
                        style={{
                          backgroundColor: '#0474c9',
                          fontSize: 12,
                          borderRadius: 5,
                          padding: 5,
                        }}
                        onClick={() =>
                          window.open(
                            'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + hit.symbol,
                            '_blank'
                          )
                        }
                      >
                        <div style={{ alignItems: 'center', display: 'flex' }}>
                          <h4 style={{ fontWeight: 'bolder', paddingLeft: 2 }}>{hit.symbol}</h4>

                        </div>
                      </button>
                    </td>
                    <td className="text-xs py-2 px-4 border-b text-center">${hit.lowestPrice}</td>

                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ padding: 5 }}>
              <h5 style={{ margin: 0, padding: 0, color: 'red', fontSize: 12 }}>No lowest prices hit.</h5>
            </div>
          )}
        </div>
      ) : null}

    </div>
  ) : null;
};

export default WatchersComponent;
